import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon, Tag } from '@fourthwall/components';
import * as S from './styled';
export const SettingsMenuItem = ({ label, icon, activeIcon, to, tag, items, }) => {
    const location = useLocation();
    const matched = useMemo(() => {
        return location.pathname === to || location.pathname.startsWith(`${to}/`);
    }, [location.pathname, to]);
    const hasChildren = !!items?.length;
    const shouldShowChildren = useMemo(() => {
        return hasChildren && (matched || (items || []).some((item) => location.pathname === item.to));
    }, [hasChildren, matched, items, location.pathname]);
    return (React.createElement(S.Container, null,
        React.createElement(S.Link, { to: to, "$active": matched },
            React.createElement(S.Wrapper, null,
                icon ? (React.createElement(Icon, { component: matched ? activeIcon || icon : icon, height: 16 })) : (React.createElement(S.Spacer, null)),
                React.createElement(S.Label, null, label),
                tag && (React.createElement(S.TagWrapper, null,
                    React.createElement(Tag, { label: tag, appearance: "strong" }))))),
        shouldShowChildren && (React.createElement(S.ChildrenContainer, null, (items || []).map((item) => (React.createElement(SettingsMenuItem, { key: item.label, label: item.label, to: item.to, tag: item.tag })))))));
};
